export default __webpack_public_path__ + "e0c4babdf8749b53ba8434f641b358ac.png";